<template>
	<div style="position: relative;">
		<b-overlay :show="loading" no-wrap />
		<div>
			<div>
				<section v-if="ratePlanModel.id>0">

					<b-card class="mb-4">
						<b-overlay :show="!editingPricesSaved" no-wrap >
							<template #overlay>{{ $t("global.saveYourChanges") }}</template>
						</b-overlay>
						<b-row>
							<b-col md="6">
								<p><strong>{{ $t("global.name") }}</strong> [{{ ratePlanModel.id }}]{{ ratePlanModel.name }}</p>
								<p><strong>{{ $t("ratePlan.operationArea") }}:</strong> {{ zonedAreaForPrice.name }}</p>
								<p><strong>{{ $t("ratePlan.startDate") }}:</strong> {{ formatDate(ratePlanModel.startDate) }}</p>
								<p><strong>{{ $t("ratePlan.endDate")}}</strong> {{ formatDate(ratePlanModel.endDate) }}</p>
							</b-col>
							<b-col md="6">
								<p><strong>{{ $t("global.description") }}:</strong> {{ ratePlanModel.description }}</p>
								<p><strong>{{ $t("global.serviceTypes") }}:</strong></p>
								<div>
									<b-badge v-for="service in ratePlanModel.serviceTypes" :key="service.id" variant="info" class="m-1 p-1">
									{{ service.name }}
									</b-badge>
								</div>
								<b-button variant="outline-info" class="mt-1" @click="manageServiceTypes" :disabled="!editingPricesSaved">
									<md-icon icon="shopping_cart" ></md-icon> {{ $t("global.manage") }}
								</b-button>
							</b-col>
						</b-row>
					</b-card>
				</section>
				<section class="m-3 map-container" v-if="selectedFromAndTo">
					<leafletMap ref="map-component" :map-options="{zoomControl: true,scrollWheelZoom: false}"></leafletMap>
				</section>
				<b-modal title="Manage Service Types" ref="modal-service-types-manager" hide-footer>
					<ServiceTypeManager
					v-if="showModuleServiceTypes"
					:ratePlanId="ratePlanModel.id"
					:initialSelectedServiceTypes="ratePlanModel.serviceTypes.map(service => service.id)"
					@done="doneServiceTypes"
					/>
				</b-modal>

				<b-form @submit.prevent="onSave">

					<b-row>

						<b-col lg="3">
							<b-card>
								<b-overlay :show="!editingPricesSaved" no-wrap >
									<template #overlay>SAVE YOUR CHANGES</template>
								</b-overlay>
								<h4 class="text-center">{{ $t("ratePlan.selectOrigin") }}</h4>
								<hr>
								<div
										class="mb-2"
										v-for="(zone,i) in zones"
										:key="i"
								>
									<b-input-group class="input-groups">
										<b-button :disabled="loadingPrices" size="lg" block @click="editingOriginZone = zone" class="zone-button" :variant="editingOriginZone.id == zone.id ? 'primary' : 'outline-primary' " >{{zone.name}} <md-icon v-if="editingOriginZone.id == zone.id" style="float:right" icon="arrow_forward_ios"/></b-button>
									</b-input-group>
								</div>
							</b-card>
						</b-col>
						<b-col lg="3">
							<b-card>
								<b-overlay :show="!editingPricesSaved" no-wrap >
									<template #overlay>{{ $t("global.saveYourChanges") }}</template>
								</b-overlay>
								<h4 class="text-center">{{ $t("ratePlan.selectDestination") }}</h4>
								<hr>
								<div
										class="mb-2"
										v-for="(zone,i) in zones"
										:key="i"
								>
									<b-input-group class="input-groups">
										<b-button :disabled="loadingPrices" size="lg" block @click="editingDestinationZone = zone" class="zone-button" :variant="editingDestinationZone.id == zone.id ? 'primary' : 'outline-primary' ">
											{{zone.name}}<md-icon v-if="editingDestinationZone.id == zone.id" style="float:right" icon="arrow_forward_ios"/>
										</b-button>
									</b-input-group>
								</div>
							</b-card>
						</b-col>
						<b-col lg="4">
							<b-card class="pt-0">
								<template v-if="selectedFromAndTo">
									<h4 class="text-center">{{ $t("global.prices") }}:</h4>
									<span >
										<p class="zoneLabel" style="text-align: left;">{{editingOriginZone.name}}</p>
										<p class="zoneLabel" style="text-align: center;"><md-icon icon="trending_flat airport_shuttle trending_flat" /></p>
										<p class="zoneLabel" style="text-align: right;">{{editingDestinationZone.name}}</p>
									</span>
									<hr>

									<div v-for="(priceData,index) in editingPrices" :key="index">
										<h5 class="text-center">[{{priceData.serviceType.id}}] {{priceData.serviceType.name}}</h5>
										<b-form-row>
											<b-col>
												<b-form-group label="One Way">
													<b-input-group>
														<b-input-group-prepend is-text>$</b-input-group-prepend>
														<b-form-input  :readonly="heritance" v-model="priceData.oneway" type="number" step="0.01" required/>
														<b-input-group-append is-text>{{currency.toUpperCase()}}</b-input-group-append>
													</b-input-group>
												</b-form-group>
											</b-col>
											<b-col>
												<b-form-group label="Roundtrip">
													<b-input-group>
														<b-input-group-prepend is-text>$</b-input-group-prepend>
														<b-form-input :readonly="heritance" v-model="priceData.roundtrip" type="number" step="0.01" required  />
														<!-- <b-form-input v-model="priceData.roundtrip" type="number"  required  /> -->
														<b-input-group-append is-text>{{currency.toUpperCase()}}</b-input-group-append>
													</b-input-group>
												</b-form-group>
											</b-col>
										</b-form-row>
										<hr>
									</div>
									<p class="text-danger"> {{ $t("ratePlan.msjPrice0") }}</p>
									<b-form-checkbox class="mb-2" v-model="applyPricesInverse">{{$t("ratePlan.applyOpposite")}}</b-form-checkbox>
									<b-overlay :show="loadingPrices" no-wrap ></b-overlay>
								</template>
								<section v-else>
									<b-alert show variant="info" v-html="$t('ratePlan.selectFromAndTo')" class="text-center"></b-alert>
								</section>
							</b-card>
						</b-col>
						<b-col lg="2">
							<b-card>
								<span class="d-block" v-b-tooltip.bottom :title="heritance ? 'No es posible editar tarifas heredadas.' : ''">
									<b-button  :disabled="!selectedFromAndTo || loadingPrices" type="submit" variant="success" size="lg" block><md-icon icon="save"/><br/>
										{{$t("global.save")}}
									</b-button>
								</span>
								<br>
								<span class="d-block" v-b-tooltip.bottom :title="heritance ? 'No es posible editar tarifas heredadas.' : ''">
									<b-button :disabled="!selectedFromAndTo || loadingPrices" type="button" @click="reload" variant="warning" size="lg" block><md-icon icon="save"/><br/>
										{{$t("global.restore")}}
									</b-button>
								</span>
							</b-card>
						</b-col>
					</b-row>
				</b-form>
			</div>

		</div>
		<!----<single-get-inherited-rates ref="singleGetInheritedRates"/>---->
	</div>
</template>

<script>
//import MapZonesEditing from "./Map.vue";
//import SingleGetInheritedRates from "./SingleGetInheritedRates";
import ServiceTypeManager from "./../../rate-plans/ServiceTypesManager.vue"
import leafletMap from "./../../../helpers/Leaflet.vue"
import moment from "moment";
	export default {
		props: {
			ratePlanId: {
				type : Number,
				required: true,
			},
		},
		components: {ServiceTypeManager,leafletMap},
		data(){
			return {
				editingPrices:[],
				editingPricesBackup:[],
				// editingPricesSaved:true,
				zones:[],
				applyPricesInverse:true,
				loadingPrices:false,
				loading:true,
				heritance: false,
				editingOriginZone:{id:null},
				editingDestinationZone:{id:null},
				editingZoneNameIndex:-1,
				currencyOptions : [
					{value:'mxn',text:'MXN'},
					{value:'usd',text:'USD'}
				],
				ratePlanModel:{
					id:-1,
					name:"",
					supplierId:-1,
					salesChannelId:-1,
					zonedArea:null,
					supplierZonedArea:null,
					startDate:null,
					endDate:null,
					serviceTypes:[]

				},
				items:[],
				showModuleServiceTypes:false
			}
		},
		computed : {
			editingPricesSaved(){
				let formatted = this.editingPrices.map((item)=>{
					item.oneway = Number(item.oneway);
					item.roundtrip = Number(item.roundtrip)
					return item;
				})
				return JSON.stringify(formatted) == JSON.stringify(this.editingPricesBackup)
			},
			serviceTypesOpts(){
				return this.$root.auxVars.serviceTypesOpts.filter(st => st.value != 1)
			},

			zonedAreaForPrice(){
				if(this.ratePlanModel.supplierId>0){
					return this.ratePlanModel.supplierZonedArea;
				}
				return this.ratePlanModel.zonedArea;
			},
			endDate(){
				if(this.isEmpty(this.ratePlanModel.endDate)) return "Sin configurar"
				return this.formatDate(this.ratePlanModel.endDate)
			},
			selectedFromAndTo(){
				return (this.editingOriginZone.id>0 && this.editingDestinationZone.id>0)
			}

		},
		methods:{
			onSave(){
				this.loadingPrices = true
				let query = {
					prices: this.editingPrices.map(price => ({
						serviceTypeId:price.serviceType.id,
						oneway:price.oneway,
						roundtrip:price.roundtrip,
					})),
					applyPricesInverse:this.applyPricesInverse,
				}
				this.$root.api.put(`/rate-plans/prices/${this.ratePlanId}/${this.editingOriginZone.id}/${this.editingDestinationZone.id}`,query).then( () => {
					this.$root.showAlert('Actualización exitosa')
					this.loadPrevPrices()
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					this.loadingPrices = false
				})

			},
			getRatePlan(){
				console.log(this.ratePlanId)
				return this.$root.api.get(`/rate-plans/${this.ratePlanId}`)
			},
			fetchModel(){
				this.loading = true
				this.getRatePlan().then( res => {
					this.ratePlanModel = res.data;
					this.items = [this.ratePlanModel]
					this.currency = res.data.currency
					this.loading = false
					this.heritance 	   = res.data.parentRatePlanId !== null
					if(res.data.supplierId>0){
						this.zones = res.data.supplierZonedArea.zones
					}else{
						this.zones = res.data.zonedArea.zones
					}
				}).catch(this.$root.handleRequestError);
			},
			loadPrevPrices(){
				this.loadingPrices = true
				this.$root.api.get(`/rate-plans/prices/${this.ratePlanId}/${this.editingOriginZone.id}/${this.editingDestinationZone.id}`).then( res => {
					this.editingPrices = res.data
					this.editingPricesBackup = JSON.parse(JSON.stringify(this.editingPrices))
					this.loadingPrices = false
				}).catch(this.$root.handleRequestError);
			},

			drawZones(){
				setTimeout(()=>{
					if(this.editingOriginZone.id && this.editingDestinationZone.id){
						this.$refs['map-component'].drawZones([this.editingOriginZone,this.editingDestinationZone]);
					}
				},100)
			},
			isEmpty(val){
				if(val == undefined || val == null || val == "") return true;
				return false;
			},
			formatDate(date) {
				if(this.isEmpty(date)) return date;
				return moment(date).format("DD/MM/YYYY");
			},
			manageServiceTypes(){
				this.$refs["modal-service-types-manager"].show();
				setTimeout(() => {
					this.showModuleServiceTypes=true
				}, 0);

			},
			doneServiceTypes(){
				this.$refs["modal-service-types-manager"].hide();
				this.showModuleServiceTypes=false;
				setTimeout(() => {
					this.reload();
				}, 100);
			},
			reload(){
				this.fetchModel();
				if(this.selectedFromAndTo){
					this.loadPrevPrices();
				}

			}

		},
		async mounted(){
			await this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesOpts','suppliersOpts']})
			this.fetchModel()
			console.log("mounted:"+this.ratePlanId)
		},
		watch : {
			editingOriginZone(){
				if(this.selectedFromAndTo) this.loadPrevPrices()
				this.drawZones();
			},
			editingDestinationZone(){
				if(this.selectedFromAndTo) this.loadPrevPrices()
				this.drawZones();
			},



		}
	}
</script>

<style scoped>
	.zoneLabel{
		line-height: 20px;
		font-size: 22px;
		margin-bottom: 0;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type=number] {
		-moz-appearance: textfield;
	}

	.card-title {
		font-size: 1.5rem;
		margin-bottom: 10px;
	}
	p{
		margin-bottom: 0px ;
	}
	.card-body{
		padding:1rem;
	}
	.col-3{
		padding-left: 8px;
		padding-right: 8px;
	}
	>>>.map-leaflet{
		z-index:10;
		height: 250px;
	}

</style>
